<div class="whole-container">
    <div class="top-section-container">
        <div class="top-section generic-container">
            <div class="title-back-btn-container">
                <mat-icon class="icon" (click)="goBack()"><mat-icon>arrow_back</mat-icon></mat-icon>
                <span class="title">Secure Checkout</span>
            </div>

            <div class="purchase-secure-container">
                <span class="purchase-secure">You're almost there! Complete your purchase securely.</span>
            </div>
        </div>
    </div>

    <div class="bottom-section-container">
        <div class="bottom-section generic-container">
            <div class="address-coupon-container">
                <div class="address-section">
                    <div class="address-heading-section">
                        <div class="heading-icon-section">
                            <mat-icon class="location-icon">location_on</mat-icon>
                            <p class="address-heading">Select Delivery Address</p>
                        </div>
                        <div *ngIf="isLoggedIn; else guestUser" class="add-new-address-btn">
                            <app-button variant="white" buttonClass="shadow-btn" (onClick)="AddNewAddress()">
                                {{ "addressList.button.addAddress" | translate }}
                            </app-button>
                        </div>
                        <ng-template #guestUser>
                            <app-button variant="white" buttonClass="shadow-btn" (onClick)="AddNewAddress()">
                                {{
                                    currentUser
                                        ? ("addressList.button.changeAddress" | translate)
                                        : ("addressList.button.addAddress" | translate)
                                }}
                            </app-button>
                        </ng-template>
                    </div>

                    <div class="address-list">
                        <mat-radio-group
                            [(ngModel)]="selectedAddress"
                            (change)="onAddressChange(selectedAddress?.id!)"
                            name="selectedAddress"
                        >
                            <div class="address-container">
                                @for (address of currentUserAddresses; track $index) {
                                <div
                                    class="address-details"
                                    [ngClass]="{ 'active-address': selectedAddress === address }"
                                >
                                    <div class="radio-name-row">
                                        <mat-radio-button [value]="address" name="selectedAddress"> </mat-radio-button>
                                        <span class="customer-name">{{ address.name }}</span>
                                        &nbsp;&nbsp;&nbsp;<span class="address-type">
                                            {{ address.addressType }}
                                        </span>
                                    </div>
                                    <p class="address">{{ address.address }}</p>
                                    <p class="city">{{ address.city }}, {{ address.state }}, {{ address.pincode }}</p>
                                    <p class="mobile">Mobile : {{ address.mobileNumber }}</p>

                                    <div class="address-btn-container" *ngIf="this.isLoggedIn">
                                        <app-button variant="hero" (onClick)="editAddress(address.id)">
                                            {{ "addressList.button.edit" | translate }}
                                        </app-button>
                                        <app-button
                                            variant="hero"
                                            *ngIf="!address.isDefault && !address.isPreferred"
                                            (onClick)="deleteAddress(address)"
                                        >
                                            {{ "addressList.button.delete" | translate }}
                                        </app-button>
                                    </div>
                                </div>
                                }
                            </div>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="coupon-section" *ngIf="availableCoupons.length">
                    <div class="coupon-top-section">
                        <div class="coupon-title-icon">
                            <mat-icon class="material-icons-outlined coupon-icon">local_offer</mat-icon>
                            <p class="coupon-title">Coupon</p>
                        </div>

                        <p class="view-coupon" (click)="toggleCouponshow()">
                            {{ showCoupons ? "Hide Coupons" : "View Coupons" }}
                        </p>
                    </div>

                    <div class="coupon-applied-container" *ngIf="appliedCoupon">
                        <div class="tick-save-container">
                            <mat-icon class="applied-icon">check</mat-icon>
                            <div class="coupon-code-text-container">
                                <p class="coupon-code">{{ appliedCoupon.code }}</p>
                                <p class="coupon-applied">
                                    You save {{ "currency.rs" | translate }} {{ appliedCoupon.couponDiscount }}
                                </p>
                            </div>
                        </div>

                        <app-button variant="hero" (onClick)="removeCoupon()" *ngIf="appliedCoupon">
                            {{ "Remove" }}
                        </app-button>
                    </div>

                    <div class="separator" *ngIf="showCoupons"></div>

                    <div class="coupons-container" *ngIf="showCoupons">
                        <p class="avaialable-coupon">{{ "checkout.availableCoupons" | translate }}</p>
                        <div class="coupons">
                            @for (coupon of availableCoupons; track $index) {
                            <div class="coupon" [ngClass]="{ 'active-coupon': appliedCoupon?.id === coupon.id }">
                                <div class="coupon-code-button-container">
                                    <div class="coupon-off-container">
                                        <div class="coupon-code coupon-gradient">{{ coupon.couponCode }}</div>
                                        <span class="coupon-discount"
                                            >{{ coupon.discountPercentage }} % OFF Upto {{ "currency.rs" | translate }}
                                            {{ coupon.maxAmount }}</span
                                        >
                                    </div>

                                    <app-button
                                        variant="hero"
                                        [disabled]="
                                            appliedCoupon?.id === coupon.id ||
                                            discountedTotal <= coupon?.minPurchaseAmount!
                                        "
                                        (onClick)="applyCoupon(coupon.couponCode)"
                                    >
                                        {{ appliedCoupon?.id === coupon.id ? "Applied" : "Apply" }}
                                    </app-button>
                                </div>

                                <div class="coupon-details-section">
                                    <p class="coupon-description">{{ coupon.description }}</p>
                                    <div class="min-purchase-valid">
                                        <p class="min-purchase" *ngIf="coupon.minPurchaseAmount">
                                            {{ "checkout.minPurchase" | translate }} {{ "currency.rs" | translate }}
                                            {{ coupon.minPurchaseAmount }}
                                        </p>
                                        <p class="valid-upto">
                                            {{ "checkout.validTill" | translate }}
                                            {{ coupon.validUpTo | date: "dd/MM/yyyy" }}
                                        </p>
                                    </div>
                                    <p class="add-items" *ngIf="discountedTotal <= coupon?.minPurchaseAmount!">
                                        {{ "checkout.addMoreItem" | translate }}
                                    </p>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div class="item-section">
                <div class="delivery-icon-container">
                    <mat-icon class="material-icons-outlined delivery-icon">local_shipping</mat-icon>
                    <p class="delivery-heading">{{ "addressList.label.deliveryEstimates" | translate }}</p>
                </div>
                <div class="loading-container" *ngIf="loading">
                    <mat-spinner [diameter]="40"></mat-spinner>
                </div>
                <div class="delivery-item-container">
                    @for (item of cartItems; track $index) {
                    <div class="delivery-item">
                        <img class="item-image" [src]="item.product?.images?.imagesUrl?.[0]" />
                        <p class="estimate-text">{{ "addressList.label.deliveryBtw" | translate }}</p>
                    </div>
                    }
                </div>

                <div class="price-detail">
                    <p class="total-mrp">
                        <span>{{ "addressList.label.totalMrp" | translate }}</span
                        ><span>{{ "currency.rs" | translate }} {{ totalMRP }}</span>
                    </p>
                    <p class="store-discount">
                        <span>{{ "addressList.label.discount" | translate }}</span
                        ><span>{{ "currency.rs" | translate }} {{ storeDiscount }}</span>
                    </p>
                    <!-- <div class="separator"></div> -->
                    <p class="total-discount">
                        <span>{{ "addressList.label.subTotal" | translate }}</span
                        ><span>{{ "currency.rs" | translate }} {{ discountedTotal }}</span>
                    </p>
                    <p *ngIf="appliedCoupon" class="coupon">
                        <span>{{
                            isFirstUserCoupon()
                                ? ("checkout.firstUserCoupon" | translate)
                                : ("checkout.couponDiscount" | translate)
                        }}</span
                        ><span>{{ "currency.rs" | translate }} {{ appliedCoupon.couponDiscount }}</span>
                    </p>
                    <p class="shipping">
                        <span>{{ "checkout.shipping" | translate }}</span
                        ><span class="shipping-value"
                            ><span *ngIf="deliveryCharge">{{ "currency.rs" | translate }}</span>
                            {{
                                deliveryCharge ? "+ " + ("currency.rs" | translate) + " " + deliveryCharge : "FREE"
                            }}</span
                        >
                    </p>
                    <div class="separator"></div>
                    <p class="total-discount">
                        <span>{{ "checkout.total" | translate }}</span
                        ><span>{{ "currency.rs" | translate }}{{ total }}</span>
                    </p>
                    <p *ngIf="isUsingCoins" class="total-discount">
                        <span>{{ "checkout.coinsUsed" | translate }}</span
                        ><span>{{ "currency.rs" | translate }} {{ coinsUsed }}</span>
                    </p>
                    <p *ngIf="isUsingCoins" class="total-discount">
                        <span>{{ "checkout.amountToBePaid" | translate }}</span
                        ><span>{{ "currency.rs" | translate }} {{ amountToBePaid }}</span>
                    </p>
                    <div class="payment-details-row savings" *ngIf="storeDiscount || appliedCoupon || isUsingCoins">
                        <p>
                            {{
                                "checkout.savingsMessage"
                                    | translate
                                        : {
                                              currency: "currency.rs" | translate,
                                              amount: storeDiscount + (appliedCoupon ? appliedCoupon.couponDiscount : 0)
                                          }
                            }}
                        </p>
                    </div>

                    <div *ngIf="!isMoreOrEqualToMinOrderValue()">
                        <p class="min-purchase-message">{{ "checkout.minOrderAmount" | translate }}</p>
                    </div>

                    <div class="btn-container">
                        <app-button
                            variant="hero"
                            (onClick)="openDialogForPayment()"
                            [disabled]="!(currentUser && selectedAddress && isMoreOrEqualToMinOrderValue())"
                        >
                            {{ "Continue" }}
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
